export const DATE_FORMAT = 'DD MMM';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT_MIN = 'D/M HH:mm';
export const DATE_WITH_MONTH_AND_YEAR = 'DD MMM YYYY';
export const CURRENCIES = {
  EUR: 'EUR',
  GBP: 'GBP'
};
export const CURRENCIES_SYMBOLS = {
  EUR: '€',
  GBP: '£'
};
export const KM_TO_MILES = 0.62137;
